import React, {useState} from 'react';
import styles from './confirm-term-sheet-modal-content.module.scss';
import {Button, Col, Row, Spinner} from "react-bootstrap";
import SuccessModalContent
  from "../../../../../securities/security-details/components/modal-content-success/modal-content-success";
import {
  LISTING_CONFIRM_ERROR,
  LISTING_CONFIRM_SUCCESS, PATTERN_ALPHA_NUMERIC, PATTERN_TENOR, TERM_SHEET_CONFIRMED,
} from "../../../../../../helpr/constants";
import ErrorModalContent
  from "../../../../../securities/security-details/components/modal-content-error/modal-content-error";
import ListingService from "../../../../../../services/listing-service";
import {minMaxLengthString, required} from "../../../../../../helpr/generic-validation-rules";
import {useValidation} from "../../../../../../hooks/use-validation";
import {TextInput} from "../../../../../../components/form/form";
import * as _ from 'lodash';

const ConfirmTermSheetModalContent = ({context, onClose}) => {
  const SUCCESS_TITLE = "TERM SHEET CONFIRMED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";

  const [ page, setPage ] = useState(0);
  const [ loading, setLoading] = useState(false);
  const listingService = new ListingService();
  const {termSheet, setTermSheet} = context;

  const isinGeneratorState = useValidation(isinGeneratorValidator, isinGeneratorObj(termSheet.securityList), {border: '1px solid red'});
  const { validate, getDynamicField, getTextFieldPropsDynamic } = isinGeneratorState;

  const renderConfirmResult = () => {
    switch(page){
      case 1:
        return <SuccessModalContent title={SUCCESS_TITLE} message={LISTING_CONFIRM_SUCCESS} onClose={onClose}/>
      case 2:
        return <ErrorModalContent title={ERROR_TITLE} message={LISTING_CONFIRM_ERROR} onClose={onClose}/>
      default:
    }
  }

  const confirmTermSheet = async () => {
    const {formState, isFormValid} = validate();
    if(!isFormValid) {
      return
    }
    setLoading(true);
    try{
      const newList = termSheet.securityList.map(s => {
        const security = formState.securityList.find(state => state.id === s.id);
        return {
          ...s,
          securityId: security.securityId,
          securityCode: security.securityCode,
          save: true
        }
      })
      console.log('NEW LIST', newList);

      await listingService.confirmTermSheet(termSheet.applicationId, newList);
      setTermSheet({
        ...termSheet,
        applicationStatus: TERM_SHEET_CONFIRMED,
        securityList: newList
      })
      setPage(1);
    }catch(error){
      setPage(2);
    }finally {
      setLoading(false);
    }
  }

  return page === 0 ? (
    <div className={styles['confirm-term-sheet']}>
      <Row>
        <Col lg={12}>
          <div>
            <h1>ARE YOU SURE YOU WANT TO CONFIRM TERM SHEET?</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      {/*<Row>*/}
      {/*  <Col lg={12}>*/}
      {/*    <div>*/}
      {/*      <img alt="Confirm Term Sheet" src={confirmIcon} />*/}
      {/*    </div>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <Row>
        <Col lg={12}>
          <div>
            <h1>INPUT SECURITY ID/ISIN AND SECURITY CODE</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}><div className={styles['line']}></div></Col>
      </Row>
      { getDynamicField('securityList').map((s,i) => {
        return (
          <>
            <Row>
              <Col lg={12}>
                <div className={`${styles['security-name']} ${styles['wrap']}`}>
                  {`${i+1}. `}{s.prefShortName.value}
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <TextInput
                  inputProps={{...getTextFieldPropsDynamic('securityList','securityId', i), value: s['securityId'].value}}
                  placeholder={"Security ID/ISIN No."}
                  disabled={termSheet.securityList[i]['securityId']}
                  maxLength={12}
                  pattern={PATTERN_ALPHA_NUMERIC}
                />
              </Col>
              <Col lg={6}>
                <TextInput inputProps={{...getTextFieldPropsDynamic('securityList','securityCode', i), value: s['securityCode'].value}}
                  placeholder={"Security Code"}
                  disabled={termSheet.securityList[i]['securityCode']} maxLength={20}
                />
              </Col>
            </Row>
          </>
        )
      })
      }
      <Row>
        <Col lg={12}><div className={styles['line']}></div></Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['submit-button']}>
            <Button disabled={loading} onClick={() => confirmTermSheet()}>
              {loading ? <Spinner size="sm" animation="border"/> : 'CONFIRM'}
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={() => onClose()}>CANCEL</Button>
          </div>
        </Col>
      </Row>
    </div>
  ) : renderConfirmResult()
}

const isinGeneratorObj = (obj) => {
  let bufferObj = _.cloneDeep(obj);
  bufferObj = bufferObj.map(s => {
    delete s.save;
    return {
      ...s,
      securityId: s.securityId ? s.securityId : '',
      securityCode: s.securityCode ? s.securityCode : ''
    }
  });
  return {
    fields: {},
    dynamicFields: {
      securityList: [...bufferObj]
    }
  }
}

const isinGeneratorValidator = {
  fields: {},
  dynamicFields: {
    securityList: {
      securityId: [
        required,
        v => minMaxLengthString(v, 12, 12)
      ],
      securityCode: [
        required
      ]
    }
  }
}

export default ConfirmTermSheetModalContent;


